import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'
import { FieldLabel } from 'partner360/components/fieldLabel/FieldLabel'

import { OperatingProfitEditMode } from './components/operatingProfitEditMode/OperatingProfitEditMode'
import { OperatingProfitReadMode } from './components/operatingProfitReadMode/OperatingProfitReadMode'
import { TRANSLATION_KEYS } from './translations'

import styles from './OperatingProfit.module.scss'

export interface IOperatingProfitProps {
  profit: Nullable<number>
  yoy: Nullable<number>

  fYear?: number
}

export const OperatingProfit: FC<IOperatingProfitProps> = (props) => {
  const { profit, yoy, fYear } = props
  const isEditMode = useSelector(selectPublishingMode)

  const pYear = useMemo(() => (fYear ? fYear - 1 : 0), [fYear])

  return (
    <div className={styles.root}>
      <FieldLabel labelTranslation={TRANSLATION_KEYS.fieldLabel} fYear={pYear} />
      {!isEditMode && (
        <OperatingProfitReadMode
          profit={profit}
          yoy={yoy}
          profitTranslationKey={TRANSLATION_KEYS.profitLabel}
          yoyTranslationKey={TRANSLATION_KEYS.yoyLabel}
        />
      )}
      {isEditMode && (
        <OperatingProfitEditMode
          profit={profit}
          yoy={yoy}
          profitTranslationKey={TRANSLATION_KEYS.profitLabel}
          yoyTranslationKey={TRANSLATION_KEYS.yoyLabel}
        />
      )}
    </div>
  )
}
